import { render, staticRenderFns } from "./OurHistory.vue?vue&type=template&id=3b5321a8&"
import script from "./OurHistory.vue?vue&type=script&lang=js&"
export * from "./OurHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports